import { createContext } from 'react';
import useEventCollectorValue from './useEventCollectorValue';

type EventCollectorContextType = ReturnType<typeof useEventCollectorValue>;

const EventCollectorContext = createContext<EventCollectorContextType>(
  {} as unknown as EventCollectorContextType,
);

export default EventCollectorContext;
